// Ad platform conversion tracking helpers.
// Fires to both Microsoft UET (Bing Ads) and Google gtag (Google Ads + GA4).
//
// Event name mapping:
//   Schedule Pickup click → UET: book_appointment     / gtag: schedule_pickup_click
//   Form submit           → UET: submit_lead_form     / gtag: form_submit_lead

function pushUet(eventName, params = {}) {
  if (typeof window === "undefined") return
  window.uetq = window.uetq || []
  window.uetq.push("event", eventName, params)
}

function pushGtag(eventName, params = {}) {
  if (typeof window === "undefined") return
  if (typeof window.gtag !== "function") return
  window.gtag("event", eventName, params)
}

export function trackSchedulePickup() {
  pushUet("book_appointment", {})
  pushGtag("schedule_pickup_click", {
    event_category: "outbound",
    event_label: "cents_booking",
    link_domain: "app.trycents.com",
  })
}

export function trackQuoteFormSubmit({ email, phone } = {}) {
  const em = (email || "").toLowerCase().trim()
  const digits = (phone || "").replace(/\D/g, "")
  const normalizedPhone = digits
    ? digits.startsWith("1") ? "+" + digits : "+1" + digits
    : ""

  const uetParams = {}
  if (em || normalizedPhone) {
    uetParams.pid = {}
    if (em) uetParams.pid.em = em
    if (normalizedPhone) uetParams.pid.ph = normalizedPhone
  }
  pushUet("submit_lead_form", uetParams)

  pushGtag("form_submit_lead", {
    event_category: "form",
    event_label: "quote_form",
  })
}
